export const accessCodeKey = "ecc_codeValid";
export const currentUserKey = "ecc_loginInfo";
export class UserLoginInfo{

    username:string;
    role:string;
    token:string;
    refreshToken:string;
}
